module.exports = __webpack_public_path__ + "static/media/logo.94b118c0.png";